import { defineStore } from 'pinia'
import axios from 'axios'
import { indexes, filterData } from '@/util/helpers'

export const useUsersStore = defineStore('users', {
  state: () => ({
    allUsers: {
      items: [],
    },
    allUniverseUsers: {
      items: [],
    },
    allAppUsers: {
      items: [],
    },
    user: {},
    query: '',
    loading: false,
  }),
  actions: {    
    async loadUsers () {
        this.loading = true
        const req = await axios.get('/api/users/')
        this.allUsers = req.data
        this.loading = false
    },
    async saveUsers (data) {
        this.loading = true
        const idxs = indexes(this.allUsers.items, this.query)
        this.allUsers.items = 
            this.allUsers.items.filter((_, i) => !idxs.includes(i))
                .concat(data.items)

        await axios.post('/api/users/', this.allUsers)
        this.loading = false
    },
    async saveUniverseUsers (universe, data) {
      this.loading = true
      await axios.post(`/api/users/universe/${universe}`, data.items)
      this.loading = false
    },
    async loadUniverseUsers (universe) {
      this.loading = true
      const req = await axios.get(`/api/users/universe/${universe}`)
      this.allUniverseUsers = req.data
      this.loading = false
    },
    async saveAppUsers (universe, app, data) {
      this.loading = true
      await axios.post(`/api/universe/${universe}/apps/${app}/users/`, data.items)
      this.loading = false
    },
    async loadAppUsers (universe, app) {
      this.loading = true
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/users/`)
      this.allAppUsers = req.data
      this.loading = false
    },
    async saveAppVisitors (universe, app, data) {
      this.loading = true
      await axios.post(`/api/universe/${universe}/apps/${app}/visitors/`, data.items)
      this.loading = false
    },
    async loadAppVisitors (universe, app) {
      this.loading = true
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/visitors/`)
      this.allAppUsers = req.data
      this.loading = false
    },
  },
  getters: {    
    users () {
        return {
            items: filterData(this.allUsers.items, this.query),
        }
    },
    universeUsers () {
      return {
          items: filterData(this.allUniverseUsers.items, this.query),
      }
    },
    appUsers () {
      return {
          items: filterData(this.allAppUsers.items, this.query),
      }
    },
  },
})
